import { CheckoutAnalyticsService } from '@analytics/feature';
import { Injectable } from '@angular/core';
import { CheckoutValidator, ValidationErrorKeys, ValidationErrors } from '@checkout/const';
import { ReceiptTypeFacade } from '@checkout/data-access';
import { MyShopService } from '@my-shop/feature';
import { ShopListService } from '@shop/feature';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeliveryAddressService } from './delivery-address.service';
import { PickupService } from './pickup.service';

@Injectable({
  providedIn: 'root',
})
export class ReceiptService implements CheckoutValidator {
  receiptTypes$ = this.receiptTypeFacade.getReceiptTypes();
  activeReceiptTypeId$ = this.receiptTypeFacade.getActiveReceiptTypeId();

  constructor(
    private receiptTypeFacade: ReceiptTypeFacade,
    private deliveryAddressService: DeliveryAddressService,
    private pickupService: PickupService,
    private shopListService: ShopListService,
    private checkoutAnalyticsService: CheckoutAnalyticsService,
    private myShopService: MyShopService,
  ) {}

  setActiveReceiptType(code: string): void {
    this.receiptTypeFacade.setActiveReceiptType(code);
  }

  validate(): Observable<ValidationErrors> {
    return combineLatest({
      receiptType: this.activeReceiptTypeId$,
      activeAddressId: this.deliveryAddressService.activeAddressId$,
      activeShopId: this.pickupService.activeShopId$,
      shops: this.shopListService.shops$,
      citiesMatch: this.deliveryAddressService.addressCityMatches$,
      myShop: this.myShopService.activeShop$,
      activeShop: this.pickupService.activeShop$,
    }).pipe(
      map(
        ({
          receiptType,
          activeAddressId,
          activeShopId,
          shops = [],
          citiesMatch = [],
          myShop = undefined,
          activeShop = undefined,
        }) => {
          const validationErrors: ValidationErrors = {};

          if (receiptType === 'delivery' && !activeAddressId) {
            validationErrors[ValidationErrorKeys.DELIVERY_ADDRESS_REQUIRED] = 'Необходимо выбрать адрес доставки';
            this.checkoutAnalyticsService.alertNeedDeliveryAdress();
          }

          if (receiptType === 'delivery' && citiesMatch.length > 0 && activeAddressId) {
            validationErrors[ValidationErrorKeys.DELIVERY_CITY_MISMATCH_WITH_CURRENT_CITY] =
              'Город в адресе доставки не соответствует текущему городу';
          }

          if (receiptType === 'pickup' && shops.length > 0 && !activeShopId) {
            validationErrors[ValidationErrorKeys.PICKUP_ADDRESS_REQUIRED] = 'Необходимо выбрать адрес самовывоза';
            this.checkoutAnalyticsService.alertNeedPickupAdress();
          }

          if (
            myShop &&
            shops &&
            receiptType === 'pickup' &&
            !shops.some((shop) => shop.name === myShop.name) &&
            !shops.some((shop) => shop.name === activeShop?.name)
          ) {
            validationErrors[ValidationErrorKeys.SHOP_POSITION_NOT_AVAILABLE] =
              'В выбранном вами магазине доступны не все товары';
          }

          return validationErrors;
        },
      ),
    );
  }
}
